import { render, staticRenderFns } from "./supplierMag.vue?vue&type=template&id=2c59271c&scoped=true&"
import script from "./supplierMag.vue?vue&type=script&lang=js&"
export * from "./supplierMag.vue?vue&type=script&lang=js&"
import style0 from "./supplierMag.vue?vue&type=style&index=0&id=2c59271c&scoped=true&lang=css&"
import style1 from "./supplierMag.vue?vue&type=style&index=1&id=2c59271c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c59271c",
  null
  
)

export default component.exports